module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-7-dda4f94d350b61c635b43cef836a2532.jpg";